// extracted by mini-css-extract-plugin
export default {"container":"Project_container__vRzmu","title":"Project_title__QHSNb"};